import { authPatch } from "@api";

import { ClaimLicenseResponse } from "@pages/settings/types";

export const claimLicense = (
  licenseKey: string,
  deploymentId: string
): Promise<ClaimLicenseResponse> => {
  return authPatch<{}, ClaimLicenseResponse>(
    `/api/agent/deployments/${deploymentId}/license/${licenseKey}`,
    {}
  );
};
